import { Camera } from '@ionic-native/camera';
import { CameraService } from '../../services/camera-service/camera-service';
import { ComponentsModule } from '../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsTakePhoto } from '../../../../shared/components/sellions-take-photo/sellions-take-photo';
import { SettingsPage } from './settings';

@NgModule({
  declarations: [SettingsPage],
  imports: [ComponentsModule, IonicPageModule.forChild(SettingsPage)],
  providers: [CameraService, Camera],
  entryComponents: [SellionsTakePhoto],
})
export class SettingsPageModule {}



// WEBPACK FOOTER //
// ./src/modules/core/pages/settings/settings.module.ts